import _defineProperty from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/tannermarshall/Dev/figure53.dev/websites/node_modules/@babel/runtime/helpers/esm/createClass.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { TZDate } from "@date-fns/tz";
import { addDays, addMonths, addWeeks, addYears, differenceInCalendarDays, differenceInCalendarMonths, eachMonthOfInterval, endOfISOWeek, endOfMonth, endOfWeek, endOfYear, format, getISOWeek, getMonth, getWeek, getYear, isAfter, isBefore, isDate, isSameDay, isSameMonth, isSameYear, max, min, setMonth, setYear, startOfDay, startOfISOWeek, startOfMonth, startOfWeek, startOfYear } from "date-fns";
import { enUS } from "date-fns/locale/en-US";
import { endOfBroadcastWeek } from "../helpers/endOfBroadcastWeek.js";
import { startOfBroadcastWeek } from "../helpers/startOfBroadcastWeek.js";
/**
 * A wrapper class around [date-fns](http://date-fns.org) sharing the same
 * options.
 *
 * @since 9.2.0
 * @example
 *   const dateLib = new DateLib({ locale: es });
 *   const newDate = dateLib.addDays(new Date(), 5);
 */
export var DateLib = /*#__PURE__*/function () {
  /**
   * Creates an instance of DateLib.
   *
   * @param options The options for the date library.
   * @param overrides Overrides for the date library functions.
   */
  function DateLib(options, overrides) {
    var _this = this;
    _classCallCheck(this, DateLib);
    /**
     * Reference to the built-in Date constructor.
     *
     * @deprecated Use `newDate()` or `today()`.
     */
    this.Date = Date;
    /**
     * Creates a new date object to the today's date.
     *
     * @since 9.5.0
     * @returns The new date object.
     */
    this.today = function () {
      var _this$overrides;
      if ((_this$overrides = _this.overrides) !== null && _this$overrides !== void 0 && _this$overrides.today) {
        return _this.overrides.today();
      }
      if (_this.options.timeZone) {
        return TZDate.tz(_this.options.timeZone);
      }
      return new _this.Date();
    };
    /**
     * Creates a new date object with the specified year, month and date.
     *
     * @since 9.5.0
     * @param year The year.
     * @param monthIndex The month (0-11).
     * @param date The day of the month.
     * @returns The new date object.
     */
    this.newDate = function (year, monthIndex, date) {
      var _this$overrides2;
      if ((_this$overrides2 = _this.overrides) !== null && _this$overrides2 !== void 0 && _this$overrides2.newDate) {
        return _this.overrides.newDate(year, monthIndex, date);
      }
      if (_this.options.timeZone) {
        return new TZDate(year, monthIndex, date, _this.options.timeZone);
      }
      return new Date(year, monthIndex, date);
    };
    /**
     * Adds the specified number of days to the given date.
     *
     * @param date The date to add days to.
     * @param amount The number of days to add.
     * @returns The new date with the days added.
     */
    this.addDays = function (date, amount) {
      var _this$overrides3;
      return (_this$overrides3 = _this.overrides) !== null && _this$overrides3 !== void 0 && _this$overrides3.addDays ? _this.overrides.addDays(date, amount) : addDays(date, amount);
    };
    /**
     * Adds the specified number of months to the given date.
     *
     * @param date The date to add months to.
     * @param amount The number of months to add.
     * @returns The new date with the months added.
     */
    this.addMonths = function (date, amount) {
      var _this$overrides4;
      return (_this$overrides4 = _this.overrides) !== null && _this$overrides4 !== void 0 && _this$overrides4.addMonths ? _this.overrides.addMonths(date, amount) : addMonths(date, amount);
    };
    /**
     * Adds the specified number of weeks to the given date.
     *
     * @param date The date to add weeks to.
     * @param amount The number of weeks to add.
     * @returns The new date with the weeks added.
     */
    this.addWeeks = function (date, amount) {
      var _this$overrides5;
      return (_this$overrides5 = _this.overrides) !== null && _this$overrides5 !== void 0 && _this$overrides5.addWeeks ? _this.overrides.addWeeks(date, amount) : addWeeks(date, amount);
    };
    /**
     * Adds the specified number of years to the given date.
     *
     * @param date The date to add years to.
     * @param amount The number of years to add.
     * @returns The new date with the years added.
     */
    this.addYears = function (date, amount) {
      var _this$overrides6;
      return (_this$overrides6 = _this.overrides) !== null && _this$overrides6 !== void 0 && _this$overrides6.addYears ? _this.overrides.addYears(date, amount) : addYears(date, amount);
    };
    /**
     * Returns the number of calendar days between the given dates.
     *
     * @param dateLeft The later date.
     * @param dateRight The earlier date.
     * @returns The number of calendar days between the dates.
     */
    this.differenceInCalendarDays = function (dateLeft, dateRight) {
      var _this$overrides7;
      return (_this$overrides7 = _this.overrides) !== null && _this$overrides7 !== void 0 && _this$overrides7.differenceInCalendarDays ? _this.overrides.differenceInCalendarDays(dateLeft, dateRight) : differenceInCalendarDays(dateLeft, dateRight);
    };
    /**
     * Returns the number of calendar months between the given dates.
     *
     * @param dateLeft The later date.
     * @param dateRight The earlier date.
     * @returns The number of calendar months between the dates.
     */
    this.differenceInCalendarMonths = function (dateLeft, dateRight) {
      var _this$overrides8;
      return (_this$overrides8 = _this.overrides) !== null && _this$overrides8 !== void 0 && _this$overrides8.differenceInCalendarMonths ? _this.overrides.differenceInCalendarMonths(dateLeft, dateRight) : differenceInCalendarMonths(dateLeft, dateRight);
    };
    /**
     * Returns the months between the given dates.
     *
     * @param interval The interval to get the months for.
     */
    this.eachMonthOfInterval = function (interval) {
      var _this$overrides9;
      return (_this$overrides9 = _this.overrides) !== null && _this$overrides9 !== void 0 && _this$overrides9.eachMonthOfInterval ? _this.overrides.eachMonthOfInterval(interval) : eachMonthOfInterval(interval);
    };
    /**
     * Returns the end of the broadcast week for the given date.
     *
     * @param date The original date.
     * @returns The end of the broadcast week.
     */
    this.endOfBroadcastWeek = function (date) {
      var _this$overrides10;
      return (_this$overrides10 = _this.overrides) !== null && _this$overrides10 !== void 0 && _this$overrides10.endOfBroadcastWeek ? _this.overrides.endOfBroadcastWeek(date, _this) : endOfBroadcastWeek(date, _this);
    };
    /**
     * Returns the end of the ISO week for the given date.
     *
     * @param date The original date.
     * @returns The end of the ISO week.
     */
    this.endOfISOWeek = function (date) {
      var _this$overrides11;
      return (_this$overrides11 = _this.overrides) !== null && _this$overrides11 !== void 0 && _this$overrides11.endOfISOWeek ? _this.overrides.endOfISOWeek(date) : endOfISOWeek(date);
    };
    /**
     * Returns the end of the month for the given date.
     *
     * @param date The original date.
     * @returns The end of the month.
     */
    this.endOfMonth = function (date) {
      var _this$overrides12;
      return (_this$overrides12 = _this.overrides) !== null && _this$overrides12 !== void 0 && _this$overrides12.endOfMonth ? _this.overrides.endOfMonth(date) : endOfMonth(date);
    };
    /**
     * Returns the end of the week for the given date.
     *
     * @param date The original date.
     * @returns The end of the week.
     */
    this.endOfWeek = function (date) {
      var _this$overrides13;
      return (_this$overrides13 = _this.overrides) !== null && _this$overrides13 !== void 0 && _this$overrides13.endOfWeek ? _this.overrides.endOfWeek(date, _this.options) : endOfWeek(date, _this.options);
    };
    /**
     * Returns the end of the year for the given date.
     *
     * @param date The original date.
     * @returns The end of the year.
     */
    this.endOfYear = function (date) {
      var _this$overrides14;
      return (_this$overrides14 = _this.overrides) !== null && _this$overrides14 !== void 0 && _this$overrides14.endOfYear ? _this.overrides.endOfYear(date) : endOfYear(date);
    };
    /**
     * Formats the given date using the specified format string.
     *
     * @param date The date to format.
     * @param formatStr The format string.
     * @returns The formatted date string.
     */
    this.format = function (date, formatStr) {
      var _this$overrides15;
      var formatted = (_this$overrides15 = _this.overrides) !== null && _this$overrides15 !== void 0 && _this$overrides15.format ? _this.overrides.format(date, formatStr, _this.options) : format(date, formatStr, _this.options);
      if (_this.options.numerals && _this.options.numerals !== "latn") {
        return _this.replaceDigits(formatted);
      }
      return formatted;
    };
    /**
     * Returns the ISO week number for the given date.
     *
     * @param date The date to get the ISO week number for.
     * @returns The ISO week number.
     */
    this.getISOWeek = function (date) {
      var _this$overrides16;
      return (_this$overrides16 = _this.overrides) !== null && _this$overrides16 !== void 0 && _this$overrides16.getISOWeek ? _this.overrides.getISOWeek(date) : getISOWeek(date);
    };
    /**
     * Returns the month of the given date.
     *
     * @param date The date to get the month for.
     * @returns The month.
     */
    this.getMonth = function (date) {
      var _this$overrides17;
      return (_this$overrides17 = _this.overrides) !== null && _this$overrides17 !== void 0 && _this$overrides17.getMonth ? _this.overrides.getMonth(date, _this.options) : getMonth(date, _this.options);
    };
    /**
     * Returns the year of the given date.
     *
     * @param date The date to get the year for.
     * @returns The year.
     */
    this.getYear = function (date) {
      var _this$overrides18;
      return (_this$overrides18 = _this.overrides) !== null && _this$overrides18 !== void 0 && _this$overrides18.getYear ? _this.overrides.getYear(date, _this.options) : getYear(date, _this.options);
    };
    /**
     * Returns the local week number for the given date.
     *
     * @param date The date to get the week number for.
     * @returns The week number.
     */
    this.getWeek = function (date) {
      var _this$overrides19;
      return (_this$overrides19 = _this.overrides) !== null && _this$overrides19 !== void 0 && _this$overrides19.getWeek ? _this.overrides.getWeek(date, _this.options) : getWeek(date, _this.options);
    };
    /**
     * Checks if the first date is after the second date.
     *
     * @param date The date to compare.
     * @param dateToCompare The date to compare with.
     * @returns True if the first date is after the second date.
     */
    this.isAfter = function (date, dateToCompare) {
      var _this$overrides20;
      return (_this$overrides20 = _this.overrides) !== null && _this$overrides20 !== void 0 && _this$overrides20.isAfter ? _this.overrides.isAfter(date, dateToCompare) : isAfter(date, dateToCompare);
    };
    /**
     * Checks if the first date is before the second date.
     *
     * @param date The date to compare.
     * @param dateToCompare The date to compare with.
     * @returns True if the first date is before the second date.
     */
    this.isBefore = function (date, dateToCompare) {
      var _this$overrides21;
      return (_this$overrides21 = _this.overrides) !== null && _this$overrides21 !== void 0 && _this$overrides21.isBefore ? _this.overrides.isBefore(date, dateToCompare) : isBefore(date, dateToCompare);
    };
    /**
     * Checks if the given value is a Date object.
     *
     * @param value The value to check.
     * @returns True if the value is a Date object.
     */
    this.isDate = function (value) {
      var _this$overrides22;
      return (_this$overrides22 = _this.overrides) !== null && _this$overrides22 !== void 0 && _this$overrides22.isDate ? _this.overrides.isDate(value) : isDate(value);
    };
    /**
     * Checks if the given dates are on the same day.
     *
     * @param dateLeft The first date to compare.
     * @param dateRight The second date to compare.
     * @returns True if the dates are on the same day.
     */
    this.isSameDay = function (dateLeft, dateRight) {
      var _this$overrides23;
      return (_this$overrides23 = _this.overrides) !== null && _this$overrides23 !== void 0 && _this$overrides23.isSameDay ? _this.overrides.isSameDay(dateLeft, dateRight) : isSameDay(dateLeft, dateRight);
    };
    /**
     * Checks if the given dates are in the same month.
     *
     * @param dateLeft The first date to compare.
     * @param dateRight The second date to compare.
     * @returns True if the dates are in the same month.
     */
    this.isSameMonth = function (dateLeft, dateRight) {
      var _this$overrides24;
      return (_this$overrides24 = _this.overrides) !== null && _this$overrides24 !== void 0 && _this$overrides24.isSameMonth ? _this.overrides.isSameMonth(dateLeft, dateRight) : isSameMonth(dateLeft, dateRight);
    };
    /**
     * Checks if the given dates are in the same year.
     *
     * @param dateLeft The first date to compare.
     * @param dateRight The second date to compare.
     * @returns True if the dates are in the same year.
     */
    this.isSameYear = function (dateLeft, dateRight) {
      var _this$overrides25;
      return (_this$overrides25 = _this.overrides) !== null && _this$overrides25 !== void 0 && _this$overrides25.isSameYear ? _this.overrides.isSameYear(dateLeft, dateRight) : isSameYear(dateLeft, dateRight);
    };
    /**
     * Returns the latest date in the given array of dates.
     *
     * @param dates The array of dates to compare.
     * @returns The latest date.
     */
    this.max = function (dates) {
      var _this$overrides26;
      return (_this$overrides26 = _this.overrides) !== null && _this$overrides26 !== void 0 && _this$overrides26.max ? _this.overrides.max(dates) : max(dates);
    };
    /**
     * Returns the earliest date in the given array of dates.
     *
     * @param dates The array of dates to compare.
     * @returns The earliest date.
     */
    this.min = function (dates) {
      var _this$overrides27;
      return (_this$overrides27 = _this.overrides) !== null && _this$overrides27 !== void 0 && _this$overrides27.min ? _this.overrides.min(dates) : min(dates);
    };
    /**
     * Sets the month of the given date.
     *
     * @param date The date to set the month on.
     * @param month The month to set (0-11).
     * @returns The new date with the month set.
     */
    this.setMonth = function (date, month) {
      var _this$overrides28;
      return (_this$overrides28 = _this.overrides) !== null && _this$overrides28 !== void 0 && _this$overrides28.setMonth ? _this.overrides.setMonth(date, month) : setMonth(date, month);
    };
    /**
     * Sets the year of the given date.
     *
     * @param date The date to set the year on.
     * @param year The year to set.
     * @returns The new date with the year set.
     */
    this.setYear = function (date, year) {
      var _this$overrides29;
      return (_this$overrides29 = _this.overrides) !== null && _this$overrides29 !== void 0 && _this$overrides29.setYear ? _this.overrides.setYear(date, year) : setYear(date, year);
    };
    /**
     * Returns the start of the broadcast week for the given date.
     *
     * @param date The original date.
     * @returns The start of the broadcast week.
     */
    this.startOfBroadcastWeek = function (date) {
      var _this$overrides30;
      return (_this$overrides30 = _this.overrides) !== null && _this$overrides30 !== void 0 && _this$overrides30.startOfBroadcastWeek ? _this.overrides.startOfBroadcastWeek(date, _this) : startOfBroadcastWeek(date, _this);
    };
    /**
     * Returns the start of the day for the given date.
     *
     * @param date The original date.
     * @returns The start of the day.
     */
    this.startOfDay = function (date) {
      var _this$overrides31;
      return (_this$overrides31 = _this.overrides) !== null && _this$overrides31 !== void 0 && _this$overrides31.startOfDay ? _this.overrides.startOfDay(date) : startOfDay(date);
    };
    /**
     * Returns the start of the ISO week for the given date.
     *
     * @param date The original date.
     * @returns The start of the ISO week.
     */
    this.startOfISOWeek = function (date) {
      var _this$overrides32;
      return (_this$overrides32 = _this.overrides) !== null && _this$overrides32 !== void 0 && _this$overrides32.startOfISOWeek ? _this.overrides.startOfISOWeek(date) : startOfISOWeek(date);
    };
    /**
     * Returns the start of the month for the given date.
     *
     * @param date The original date.
     * @returns The start of the month.
     */
    this.startOfMonth = function (date) {
      var _this$overrides33;
      return (_this$overrides33 = _this.overrides) !== null && _this$overrides33 !== void 0 && _this$overrides33.startOfMonth ? _this.overrides.startOfMonth(date) : startOfMonth(date);
    };
    /**
     * Returns the start of the week for the given date.
     *
     * @param date The original date.
     * @returns The start of the week.
     */
    this.startOfWeek = function (date) {
      var _this$overrides34;
      return (_this$overrides34 = _this.overrides) !== null && _this$overrides34 !== void 0 && _this$overrides34.startOfWeek ? _this.overrides.startOfWeek(date, _this.options) : startOfWeek(date, _this.options);
    };
    /**
     * Returns the start of the year for the given date.
     *
     * @param date The original date.
     * @returns The start of the year.
     */
    this.startOfYear = function (date) {
      var _this$overrides35;
      return (_this$overrides35 = _this.overrides) !== null && _this$overrides35 !== void 0 && _this$overrides35.startOfYear ? _this.overrides.startOfYear(date) : startOfYear(date);
    };
    this.options = _objectSpread({
      locale: enUS
    }, options);
    this.overrides = overrides;
  }
  /**
   * Generate digit map dynamically using Intl.NumberFormat.
   *
   * @since 9.5.0
   */
  return _createClass(DateLib, [{
    key: "getDigitMap",
    value: function getDigitMap() {
      var _this$options$numeral = this.options.numerals,
        numerals = _this$options$numeral === void 0 ? "latn" : _this$options$numeral;
      // Use Intl.NumberFormat to create a formatter with the specified numbering system
      var formatter = new Intl.NumberFormat("en-US", {
        numberingSystem: numerals
      });
      // Map Arabic digits (0-9) to the target numerals
      var digitMap = {};
      for (var i = 0; i < 10; i++) {
        digitMap[i.toString()] = formatter.format(i);
      }
      return digitMap;
    }
    /**
     * Replace Arabic digits with the target numbering system digits.
     *
     * @since 9.5.0
     */
  }, {
    key: "replaceDigits",
    value: function replaceDigits(input) {
      var digitMap = this.getDigitMap();
      return input.replace(/\d/g, function (digit) {
        return digitMap[digit] || digit;
      });
    }
    /**
     * Format number using the custom numbering system.
     *
     * @since 9.5.0
     * @param value The number to format.
     * @returns The formatted number.
     */
  }, {
    key: "formatNumber",
    value: function formatNumber(value) {
      return this.replaceDigits(value.toString());
    }
  }]);
}();
/** The default locale (English). */
export { enUS as defaultLocale } from "date-fns/locale/en-US";
/**
 * The default date library with English locale.
 *
 * @since 9.2.0
 */
export var defaultDateLib = new DateLib();
/**
 * @ignore
 * @deprecated Use `defaultDateLib`.
 */
export var dateLib = defaultDateLib;